var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 202,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.468.563H9.974C5.018.563 1 3.99 1 8.218v184.689c0 4.228 4.018 7.655 8.974 7.655h216.494c4.956 0 8.974-3.427 8.974-7.655V8.218c0-4.228-4.018-7.655-8.974-7.655z",
    fill: "#fff",
    stroke: "#E6EAEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.026 1H10.411C5.454 1 1.437 4.411 1.437 8.619v184.762c0 4.208 4.017 7.619 8.974 7.619h217.615c4.956 0 8.974-3.411 8.974-7.619V8.619C237 4.411 232.982 1 228.026 1z",
    fill: "url(#step-2_svg__paint0_linear_3334_11018)",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.838 41.582H22.874a4.491 4.491 0 00-4.487 4.495V67.43a4.491 4.491 0 004.487 4.495h54.964a4.491 4.491 0 004.487-4.495V46.077a4.491 4.491 0 00-4.487-4.495z",
    fill: "url(#step-2_svg__paint1_linear_3334_11018)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.701 53.943h-58.68a3.029 3.029 0 00-3.026 3.032 3.029 3.029 0 003.026 3.031h58.68a3.029 3.029 0 003.026-3.031 3.029 3.029 0 00-3.026-3.032z",
    fill: "url(#step-2_svg__paint2_linear_3334_11018)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.464 91.61H21.752a3.368 3.368 0 00-3.365 3.37 3.368 3.368 0 003.365 3.372h98.712a3.368 3.368 0 003.365-3.371 3.368 3.368 0 00-3.365-3.372z",
    fill: "url(#step-2_svg__paint3_linear_3334_11018)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.986 107.342H21.752a3.368 3.368 0 00-3.365 3.371 3.369 3.369 0 003.365 3.372h48.234a3.369 3.369 0 003.365-3.372 3.368 3.368 0 00-3.365-3.371z",
    fill: "url(#step-2_svg__paint4_linear_3334_11018)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.273 123.076H21.752a3.369 3.369 0 00-3.365 3.372 3.368 3.368 0 003.365 3.371h78.521a3.367 3.367 0 003.365-3.371 3.368 3.368 0 00-3.365-3.372z",
    fill: "url(#step-2_svg__paint5_linear_3334_11018)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M194.822 16.016h16.179m-45.344 0h16.179-16.179z",
    stroke: "#CBDAE8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M217.493 22.477c4.027 0 7.292-3.27 7.292-7.305 0-4.034-3.265-7.305-7.292-7.305-4.027 0-7.291 3.27-7.291 7.305 0 4.034 3.264 7.305 7.291 7.305z",
    fill: "url(#step-2_svg__paint6_linear_3334_11018)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.164 22.477c4.027 0 7.291-3.27 7.291-7.305 0-4.034-3.264-7.305-7.291-7.305-4.027 0-7.291 3.27-7.291 7.305 0 4.034 3.264 7.305 7.291 7.305z",
    fill: "url(#step-2_svg__paint7_linear_3334_11018)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188.329 22.477c4.026 0 7.291-3.27 7.291-7.305 0-4.034-3.265-7.305-7.291-7.305-4.027 0-7.292 3.27-7.292 7.305 0 4.034 3.265 7.305 7.292 7.305z",
    fill: "url(#step-2_svg__paint8_linear_3334_11018)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.509 145.553h199.668c4.956 0 8.974 4.025 8.974 8.99v13.486c0 4.965-4.018 8.99-8.974 8.99H19.509c-4.956 0-8.974-4.025-8.974-8.99v-13.486c0-4.965 4.018-8.99 8.974-8.99z",
    fill: "url(#step-2_svg__paint9_linear_3334_11018)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-2_svg__paint0_linear_3334_11018",
    x1: 119.218,
    y1: 201,
    x2: 119.218,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE7F2",
    stopOpacity: 0.795
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FF",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-2_svg__paint1_linear_3334_11018",
    x1: 82.325,
    y1: 53.349,
    x2: 27.438,
    y2: 79.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-2_svg__paint2_linear_3334_11018",
    x1: 217.727,
    y1: 53.943,
    x2: 152.995,
    y2: 53.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F245A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB65B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-2_svg__paint3_linear_3334_11018",
    x1: 123.829,
    y1: 91.609,
    x2: 18.387,
    y2: 91.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-2_svg__paint4_linear_3334_11018",
    x1: 73.352,
    y1: 107.342,
    x2: 18.387,
    y2: 107.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-2_svg__paint5_linear_3334_11018",
    x1: 103.638,
    y1: 123.076,
    x2: 18.387,
    y2: 123.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-2_svg__paint6_linear_3334_11018",
    x1: 217.493,
    y1: 4.483,
    x2: 214.113,
    y2: 27.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC64AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-2_svg__paint7_linear_3334_11018",
    x1: 159.164,
    y1: -5.915,
    x2: 159.164,
    y2: 32.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-2_svg__paint8_linear_3334_11018",
    x1: 188.329,
    y1: -5.915,
    x2: 188.329,
    y2: 32.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-2_svg__paint9_linear_3334_11018",
    x1: 228.151,
    y1: 145.553,
    x2: 10.535,
    y2: 145.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE43A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE4CAD"
  })))));
}

export default "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/step-2-b74cd64b01ffb2657c93312ff04940a1.svg";
export { SvgStep2 as ReactComponent };